import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { formatMoney } from "@finora/config";
import { api } from "../../lib/api";

function toIsoDate(d: Date): string {
  return d.toISOString().slice(0, 10);
}
function firstOfMonth(): string {
  const d = new Date();
  d.setDate(1);
  return toIsoDate(d);
}
function today(): string {
  return toIsoDate(new Date());
}

const BILLING_TYPE_LABEL: Record<string, string> = {
  PER_TRANSACTION: "po transakciji",
  PER_DOCUMENT: "po dokumentu",
  PER_API_CALL: "po API pozivu",
  PER_UNIT: "po jedinici",
  MONTHLY: "mesečno",
  FREE: "besplatno",
};

export function BillingUsageReportTab() {
  const [from, setFrom] = useState(firstOfMonth());
  const [to, setTo] = useState(today());

  const { data, isLoading } = useQuery({
    queryKey: ["billing-usage-report", from, to],
    queryFn: () => api.getBillingUsageReport(from, to),
  });

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-end gap-3 rounded-xl border border-border bg-surface p-4 shadow-subtle">
        <div>
          <label className="mb-1 block text-xs text-slate-500">Od</label>
          <input
            type="date"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            className="h-9 rounded-lg border border-border px-2 text-sm focus:border-brand focus:outline-none"
          />
        </div>
        <div>
          <label className="mb-1 block text-xs text-slate-500">Do</label>
          <input
            type="date"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            className="h-9 rounded-lg border border-border px-2 text-sm focus:border-brand focus:outline-none"
          />
        </div>
      </div>

      {isLoading ? (
        <p className="text-sm text-slate-500">Učitavanje...</p>
      ) : !data || data.services.length === 0 ? (
        <p className="rounded-xl border border-border bg-surface p-4 text-sm text-slate-400 shadow-subtle">
          Nema naplaćenih usluga po jedinici u ovom periodu.
        </p>
      ) : (
        <div className="rounded-xl border border-border bg-surface shadow-subtle">
          <table>
            <thead>
              <tr>
                <th>Usluga</th>
                <th>Način naplate</th>
                <th>Količina</th>
                <th>Broj događaja</th>
                <th>Iznos</th>
              </tr>
            </thead>
            <tbody>
              {data.services.map((s) => (
                <tr key={s.key}>
                  <td className="font-medium text-slate-800">{s.name}</td>
                  <td className="text-slate-500">{BILLING_TYPE_LABEL[s.billingType] ?? s.billingType}</td>
                  <td>{s.quantity}</td>
                  <td>{s.eventCount}</td>
                  <td className="font-medium">{formatMoney(s.totalCost)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4} className="text-right font-semibold text-slate-700">
                  Ukupno:
                </td>
                <td className="font-semibold text-slate-900">{formatMoney(data.grandTotal)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}
